import { type IResponseAccountDTO, type IUserDTO } from '../services';

export const generateUserUrlSearchParams = (
  userData: IUserDTO,
  token: string
): URLSearchParams => {
  const params = new URLSearchParams();

  params.append('firstName', userData.firstName);
  params.append('lastName', userData.lastName);
  params.append('email', userData.email);
  params.append('id', userData.id.toString());
  params.append(
    'currentTermsVersionAccepted',
    userData.currentTermsVersionAccepted?.toString() ?? '0'
  );
  // Roles
  userData.roles.forEach((role) => params.append('roles', role));

  if (userData.clientId != null && userData.clientId > 0) {
    params.append('clientId', userData.clientId.toString());
  }
  if (userData.status) params.append('status', userData.status);
  if (userData.settings && userData.settings.length > 0) {
    params.append('settings', JSON.stringify(userData.settings));
  }
  if (userData.accountFile) {
    params.append('accountFile', JSON.stringify(userData.accountFile));
  }
  if (userData.agencies && userData.agencies.length > 0) {
    params.append('agencies', JSON.stringify(userData.agencies));
  }

  params.append('token', token);
  return params;
};
type IUserInfoUrl = Pick<IResponseAccountDTO, 'data' | 'token'>;

export const parseUserUrlSearchParams = (
  params: URLSearchParams
): IUserInfoUrl => {
  const parseJson = (value: string | null): unknown => {
    try {
      return value ? JSON.parse(value) : undefined;
    } catch {
      return undefined;
    }
  };

  return {
    token: params.get('token') ?? '',
    data: {
      firstName: params.get('firstName') ?? '',
      lastName: params.get('lastName') ?? '',
      email: params.get('email') ?? '',
      roles: params.getAll('roles'),
      clientId: params.get('clientId')
        ? Number(params.get('clientId'))
        : undefined,
      id: Number(params.get('id')),
      status: params.get('status') ?? undefined,
      settings: parseJson(params.get('settings')) as IUserDTO['settings'],
      accountFile: parseJson(
        params.get('accountFile')
      ) as IUserDTO['accountFile'],
      agencies: parseJson(params.get('agencies')) as IUserDTO['agencies'],
      currentTermsVersionAccepted: parseInt(
        params.get('currentTermsVersionAccepted') ?? '0',
        10
      ),
    },
  };
};
